export default "__VITE_ASSET__efc3af88__"